module.exports = __webpack_public_path__ + "static/media/icon-event__fin-de-las-colonias-hover.bf94d12f.svg";